import React from "react";
import "./Box.css"

export const Box = ({value, onClick, win}) => {
    const style = value === "X"?"box x":"box o";
    const winCheck = win === null?'':'green';

    return (
        <button className={`${style} ${winCheck}`} onClick={onClick}>{value}</button>
    )
}